var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71625 0 0 6.71625 0 15C0 23.2838 6.71625 30 15 30C23.2838 30 30 23.2838 30 15C30 6.71625 23.2838 0 15 0ZM15 2.5C17.9975 2.5 20.7513 3.56125 22.9062 5.32625L15 13.2325L7.09375 5.32625C9.25 3.56125 12.0037 2.5 15 2.5ZM2.5 15C2.5 12.0025 3.56125 9.24875 5.32625 7.09375L13.2325 15L5.32625 22.9062C3.56125 20.75 2.5 17.9963 2.5 15ZM15 27.5C12.0025 27.5 9.24875 26.4388 7.09375 24.6737L15 16.7675L22.9062 24.6737C20.75 26.4388 17.9963 27.5 15 27.5ZM24.6737 22.9062L16.7675 15L24.6737 7.09375C26.4388 9.25 27.5 12.0037 27.5 15C27.5 17.9963 26.4388 20.7513 24.6737 22.9062Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.c089ef6ed4c2d2da694b983822885fed.svg";
export { ForwardRef as ReactComponent };